import { ErrorType } from "../types";

export const buildError = (
  type: ErrorType | undefined,
  message: string | undefined
): Error => {
  return new Error(
    `${type ? type : ErrorType.HANDLED}:${message ? message : ""}`
  );
};

export const getError = (error: Error): { type: string; message: string } => {
  return {
    type: error.message.split(":")[0],
    message: error.message.split(":")[1],
  };
};
